<template>
    <MainContentSearchable title="Listado de frecuencias para los pagos a plazos" id="frecuencias" v-model="filters" :meta="loading ? {} : frecuencias.meta" @updated="getFrecuencias">
        <template v-slot:header>
            <div class="ml-auto">
                <router-link :to="{ name: 'back.frecuencias.crear' }" class="btn btn-primary mb-3" target="blank">Nueva frecuencia</router-link>
            </div>
        </template>
        <template v-slot:content>
            <div>
                <b><p>*En este apartado es donde vamos a crear las frecuencias con las que se cobrará el importe, en caso de activar el pago a plazos en la categoría</p></b>
                <div class="table-responsive has-options">
                    <b-table hover :items="frecuencias.data" :fields="fields" id="frecuencias-table">
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownComponent v-bind:options="[
                                { type: 'action', action:() => showModal('editar-' + item.id), label: 'Editar'},
                                { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                            ]"/>
                            <EditarFrecuencia :frecuencia="item" v-on:close="closeModal"></EditarFrecuencia>
                            <BorrarFrecuencia :frecuencia="item" v-on:close="closeModal"></BorrarFrecuencia>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
import EditarFrecuencia from './modals/EditarFrecuencia';
import BorrarFrecuencia from './modals/BorrarFrecuencia';
import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";

export default {
    data() {
        return {
            frecuencias: {},
            loading: false,
            filters: {
                per_page: 10,
                page: 1,
                search: ''
            },
            fields: [
                { key: "cantidad", label: "Cantidad", class: 'text-center' },
                { key: "frecuencia", label: "Frecuencia", class: 'text-center' },
                { key: "opciones", label: "Acciones", class: 'text-center' }
            ],
        }
    },
    created() {
        this.getFrecuencias();
    },
    methods: {
        getFrecuencias() {
            this.loading = true;

            let params = {
                filters: this.filters,
            };
            this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.index'), params).then(res => {
                this.frecuencias = res.data;
            }).finally(() => this.loading = false);
        },
        borrar(id) {
            this.loading = true;

            var params = {
                filters : {},
                frecuencia_id: id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.borrar'), params).then(res => {
                this.$toast.success(res.data.message, {});
                this.getFrecuencias();
            }).finally(() => this.loading = false);
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
            this.getFrecuencias();
        },
    },
    components: {
        MainContentSearchable, OpcionesDropdownComponent, BorrarFrecuencia, EditarFrecuencia
    }
}
</script>